import { Component, OnInit, OnDestroy } from "@angular/core";
import { BreakpointObserver, Breakpoints } from "@angular/cdk/layout";
import { Observable, Subscription } from "rxjs";
import { map } from "rxjs/operators";
import { Router, NavigationEnd } from "@angular/router";
import { PermisosService } from "src/app/_services/permisos.service";
import { Permisos } from "../../../../_models/sesion/permisos";
import { LoginManager } from "src/app/_managers/login-manager.services";
import moment from 'moment';
import { MessagesManager } from '../../../../_managers/messages-manager.service';
import { MENSAJES } from '../../../../user/general-data';
import { ReportManager } from '../../../../_managers/report-manager.services';

@Component({
  selector: "app-navbar",
  templateUrl: "./navbar.component.html",
  styleUrls: ["./navbar.component.scss"],
})
export class NavbarComponent implements OnInit, OnDestroy {
  public viewSidenav = false;
  myDate = new Date();
  private refNativagate = new Subscription();
  public url = "";
  public permisos: Permisos[];
  public datos: any;
  public fecha = new Date();
  public today: any;
  public notification = false;
  loading = false;
  MsjsList: any[] = [];
  subcritions = new Subscription();
  viewMsjs = false;
  oficina:string;
  public menuOptions = {
    nivel: [],
    secuencia: [],
  };
  isHandset$: Observable<boolean> = this.breakpointObserver
    .observe(Breakpoints.Handset)
    .pipe(map((result) => result.matches));

  constructor(
    private messagesManager: MessagesManager,
    private breakpointObserver: BreakpointObserver,
    private router: Router,
    private permisoService: PermisosService,
    private loginManager: LoginManager,
    private reportManager: ReportManager
  ) {}

  ngOnInit() {
    this.validateLogin();
    this.refNativagate = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.validateLogin();
      }
    });
    this.obtenerPermisos();
    this.obtenerDatos();
    this.today = moment(this.fecha).format('DD/MM/YYYY');
     this.subcritions.add(this.messagesManager.getLoading().subscribe(load => this.loading = load));
     this.messagesManager.getAllMessages();
     this.subcritions.add(this.messagesManager.getListMessages().subscribe(list => {
       this.MsjsList = list;
     }));
     
     /*de descomenta lo de arriba y se quita lo de abajo para arrancar los servicios*/
    //this.MsjsList = MENSAJES;
  }

  toggleOpenOption(item) {
    console.log("item", item);
  }

  obtenerPermisos() {
    let variable = JSON.parse(localStorage.getItem("currentUser"));
    return this.permisoService
      .getPermisos(variable.codinter)
      .subscribe((permiso: Permisos[]) => {
        this.permisos = permiso;
        this.permisos.forEach((element) => {
          let opt = element.NIVEL;
          if (opt == 1) {
            console.log(element.NIVEL, element.SECUENCIA, element.DESAPLIC);
          } else if (opt == 2) {
            console.log(element.NIVEL, element.SECUENCIA, element.DESAPLIC);
          } else if (opt == 3) {
            console.log(element.NIVEL, element.SECUENCIA, element.DESAPLIC);
          } else if (opt == 4) {
            console.log(element.NIVEL, element.SECUENCIA, element.DESAPLIC);
          }
        });
      });
  }

  obtenerDatos() {
    let variable = JSON.parse(localStorage.getItem("currentUser"));
    return this.permisoService
      .getDatos(variable.codinter)
      .subscribe((permiso) => {
        this.datos = permiso;
      });
  }
  ngOnDestroy() {
    this.refNativagate.unsubscribe();
  }

  validateLogin() {
    this.url = this.router.url;
    /*let login = this.authenticationService.isLogin();*/
    let login = this.loginManager.isLogin();
    // if(this.url === '/login' || !this.loginManager.isAuth()){
    if (this.url === "/login" && !login) {
      this.viewSidenav = false;
    } else {
      this.viewSidenav = true;
    }
  }

  logout() {
    /*this.authenticationService.logout();*/
    this.loginManager.Logout();
    this.router.navigate(['/login']);
  }

  firstFourWords(palabra) {
    return palabra.split(" ", 4).join(' ');
  }

  NextFourWords(palabra) {
    return palabra.split(" ", 8).slice(4, 8).join(' ');
  }

  InverView() {
    this.viewMsjs = !this.viewMsjs;
  }
  reporter(oficina){
    let previousMonth = new Date(this.myDate);
    previousMonth.setMonth(this.myDate.getMonth()-1);
    this.reportManager.submitPrinRen(oficina,0,0,0,previousMonth,this.myDate);
  }

  reportec(oficina){
    let previousMonth = new Date(this.myDate);
    previousMonth.setMonth(this.myDate.getMonth()-1);
    this.reportManager.submitPrinCob(previousMonth,this.myDate, 0,0); // + ,0,0
  }

  getProveedor(){
    this.reportManager.getReport('odontologos');
  }

  getOftalmologo(){
    this.reportManager.getReport('oftalmologos');
  }

  getDermatologo(){
    this.reportManager.getReport('dermatologo');
  }

  getAuxiliar(){
    this.reportManager.getReport('auxiliar');
  }

  getFunerario(){
    this.reportManager.getReport('funerario');
  }
  
  getCuenta(){
    this.reportManager.getReport('CuentasBancarias');
  }

}
